import type { BusState, TrafficCar } from '../game/RunState';

/** Lateral overlap below this is a scrape (stumble), above it a crash. */
const GRAZE_OVERLAP = 0.7;
const CLOSE_CALL_GAP = 0.9;

export type Contact = 'none' | 'graze' | 'hit' | 'cleared';

function lateralOverlap(bus: BusState, car: TrafficCar): number {
  const halfWidths = (bus.size.width + car.kind.width) / 2;
  return halfWidths - Math.abs(bus.x - car.x);
}

function longitudinalOverlap(bus: BusState, car: TrafficCar): boolean {
  return Math.abs(bus.s - car.s) < (bus.size.length + car.kind.length) / 2;
}

export function checkContact(bus: BusState, car: TrafficCar): Contact {
  if (!longitudinalOverlap(bus, car)) return 'none';
  const overlap = lateralOverlap(bus, car);
  if (overlap <= 0) return 'none';
  if (car.kind.hoppable && bus.y > car.kind.height) return 'cleared';
  return overlap < GRAZE_OVERLAP && !car.kind.hoppable ? 'graze' : 'hit';
}

/** Passing right next to a vehicle without touching it. */
export function isCloseCall(bus: BusState, car: TrafficCar): boolean {
  if (car.kind.hoppable || !longitudinalOverlap(bus, car)) return false;
  const gap = -lateralOverlap(bus, car);
  return gap > 0 && gap < CLOSE_CALL_GAP;
}
